import { createAsyncThunk } from "@reduxjs/toolkit";
import { dbAgentRoutes } from "Constants/api";
import { getRequest, postRequest } from "Utilities/ApiHelpers/ApiHelpers.index";
import { IGetDatabasesRequestDTO } from "./types";
import { ServiceType } from "Config/types";

export const getAllDbProviders = createAsyncThunk(
  dbAgentRoutes.dbProviders,
  async () => {
    const response = await getRequest(dbAgentRoutes.dbProviders, null, true, ServiceType.Listener);
    return response.data;
  }
);

export const getDatabases = createAsyncThunk(
  dbAgentRoutes.getDabases,
  async (dataBaseInfo: IGetDatabasesRequestDTO) => {
    const response = await postRequest(
      dbAgentRoutes.getDabases,
      null,
      true,
      dataBaseInfo,
      null,
      ServiceType.Listener
    );
    return response.data;
  }
);
